import { Trans } from '@lingui/react'

import { useConfirmCalculatedIncomeMutation } from '@twisto/api-graphql'
import { TextButton } from '@twisto/components/atoms/button'
import { FlowFormSubmitButton } from '@twisto/flow-views/components'
import { useOpen } from '@twisto/hooks'

import { useFlow } from '../../flow/flow.context'

import { ReviewIncomeStartOverModal } from './review-income-start-over-modal'
import { ReviewIncomeStepHeader } from './review-income-step-header'
import * as styles from './review-income-step.styles'

export const ReviewIncomeStep = () => {
  const { isOpen, handleClose, handleOpen } = useOpen()
  const { sessionId } = useFlow<'ReviewIncomeStep'>()
  const [confirmCalculatedIncome] = useConfirmCalculatedIncomeMutation({
    variables: {
      auth: { sessionId },
    },
  })

  return (
    <>
      <ReviewIncomeStepHeader />
      <TextButton
        fullWidth
        color="ghost"
        css={styles.confirmButton}
        onClick={handleOpen}
      >
        <Trans id="flow.reviewIncomeStep.editButton" />
      </TextButton>
      {/* Confirm Income button */}
      <FlowFormSubmitButton
        buttonText={<Trans id="flow.reviewIncomeStep.confirmButton" />}
        onSubmit={confirmCalculatedIncome}
      />
      <ReviewIncomeStartOverModal opened={isOpen} onClose={handleClose} />
    </>
  )
}
